var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "beee3a4a-edfd-4ee7-884d-3be245173967",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.9 254.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M169.21,226.87C181.36,196.08,211.37,173,246.47,173s65.11,23.1,77.25,53.89H370c-13.65-55.57-63.79-98.11-123.56-98.11S136.55,171.3,122.9,226.87Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.72,285.13C311.58,315.92,281.57,339,246.47,339s-65.11-23.1-77.26-53.89H122.9c13.65,55.57,63.79,98.11,123.57,98.11S356.38,340.7,370,285.13Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92,275.55a9.8,9.8,0,0,1-10,9.58H102a9.8,9.8,0,0,1-10-9.58v-39.1a9.8,9.8,0,0,1,10-9.58H390.91a9.8,9.8,0,0,1,10,9.58v39.1Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.94,230.68h9.11l19,28.94a75.24,75.24,0,0,1,4.17,7.76h.14s-.49-4.8-.49-7.76V230.68h9v50.11h-9l-19-28.87a75.24,75.24,0,0,1-4.17-7.76h-.14s.5,4.8.5,7.76v28.87H98.94Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,229.83c14.75,0,25.9,11.23,25.9,25.55,0,14.75-11.15,26.26-25.9,26.26s-25.91-11.51-25.91-26.26C149.12,241.06,160.27,229.83,175,229.83Zm0,43.48c9.17,0,16.51-7.62,16.51-17.93,0-9.88-7.34-17.22-16.51-17.22s-16.52,7.34-16.52,17.22C158.51,265.69,165.85,273.31,175,273.31Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.32,230.68h9.11v50.11h-9.11Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.43,229.83c12.21,0,18.5,6.85,18.5,6.85l-4.38,6.77a22.1,22.1,0,0,0-13.69-5.29c-10.59,0-16.8,7.91-16.8,17.22,0,9.53,6.42,17.93,16.87,17.93,8.68,0,14.54-6.35,14.54-6.35l4.8,6.56a27,27,0,0,1-19.7,8.12c-15.31,0-25.9-11.36-25.9-26.12C245.67,241,256.68,229.83,271.43,229.83Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.83,229.83c14.75,0,25.9,11.23,25.9,25.55,0,14.75-11.15,26.26-25.9,26.26s-25.91-11.51-25.91-26.26C295.92,241.06,307.07,229.83,321.83,229.83Zm0,43.48c9.17,0,16.51-7.62,16.51-17.93,0-9.88-7.34-17.22-16.51-17.22s-16.52,7.34-16.52,17.22C305.31,265.69,312.65,273.31,321.83,273.31Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,230.68h9.11l19,28.94a75.24,75.24,0,0,1,4.17,7.76h.14s-.5-4.8-.5-7.76V230.68h9v50.11h-9l-19-28.87a75.24,75.24,0,0,1-4.17-7.76h-.14s.5,4.8.5,7.76v28.87H357Z",
    transform: "translate(-92.02 -128.76)",
    style: {
      fill: "#afafaf"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportNone);
export default __webpack_public_path__ + "static/media/transport-none.6dd56510.svg";
export { ForwardRef as ReactComponent };